import type { ReactNode } from 'react'
import { Card } from '../card/Card'
import type { CardSpan } from '../card/Card'
import { FieldGrid } from './FieldGrid'
import type { FieldColumns } from './FieldGrid'

interface Props {
  title: string
  help?: ReactNode
  meta?: ReactNode
  /** Breite im Kartenraster — eine Detailseite ist ein Dashboard aus Abschnitten. */
  span?: CardSpan
  columns?: FieldColumns
  children: ReactNode
}

/**
 * Ein Abschnitt einer Detailseite: Karte mit Überschrift und beschrifteten
 * Werten darin.
 *
 * Nur die Zusammenlegung von `Card` und `FieldGrid` — die beiden häufigsten
 * Bausteine einer Detailseite. Wer eine Karte mit anderem Inhalt braucht,
 * nimmt `Card` direkt.
 *
 * Einen eigenen Seitenrahmen gibt es nicht: Titel und Untertitel der Seite
 * stehen in der Kopfzeile von `AppShell` und damit an derselben Stelle wie bei
 * jeder Liste.
 */
export function DetailSection({ title, help, meta, span = 6, columns = 2,
                               children }: Props) {
  return (
    <Card title={title} help={help} meta={meta} span={span}>
      <FieldGrid columns={columns}>{children}</FieldGrid>
    </Card>
  )
}
